module.exports = __webpack_public_path__ + "img/mobile-splash.b36327f0.png";